export default "__VITE_ASSET__ElAVgCM2__"